<template>
  <b-field grouped>
    <b-field label="POS番号" expanded>
      <b-input v-model="item.pos" :disabled="isBookedItem"></b-input>
    </b-field>
    <b-field label="POSアカウント" expanded>
      <b-input v-model="item.postAccount" :disabled="isBookedItem"></b-input>
    </b-field>
  </b-field>
</template>
<script>
export default {
  props: ['item', 'isBookedItem'],
};
</script>
